import styles from './input.module.scss';
import { useRef, useState, InputHTMLAttributes, useEffect } from 'react';
import classNames from 'classnames';

interface Props
    extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onInput' | 'value'> {
    placeholder?: string;
    type?: string;
    onInput?: (value: string) => void;
    disabled?: boolean;
    value?: string;
}

const Input = (props: Props) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    const [labelUp, setLabelUp] = useState(false);

    const [currentType, setCurrentType] = useState(props.type ?? 'text');

    useEffect(() => {
        if (props.value && props.value.trim().length > 0) {
            setLabelUp(true);
        }
    }, [props.value]);

    const onFocus = () => {
        setLabelUp(true);

        if (props.type === 'date') {
            setCurrentType('date');
        }
    };

    const onBlur = () => {
        const value = inputRef.current?.value;
        const hasValue = value && value.trim().length > 0;

        if (!hasValue) {
            setLabelUp(false);

            if (props.type === 'date') {
                setCurrentType('text');
            }
        }
    };

    const { placeholder, onInput, type, disabled, value, ...rest } = props;

    const effectiveType =
        props.type === 'date' && !labelUp ? 'text' : currentType;

    const finalType = props.type === 'date' && labelUp ? 'date' : effectiveType;

    return (
        <div
            className={styles.container}
            onClick={() => inputRef.current?.focus()}
        >
            <input
                ref={inputRef}
                className={styles.input}
                type={finalType ?? 'text'}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={(ev) => props.onInput?.(ev.target.value)}
                disabled={props.disabled}
                value={props.value}
                {...rest}
            />

            {placeholder && (
                <label className={classNames({ [styles.up]: labelUp })}>
                    {placeholder}
                </label>
            )}
        </div>
    );
};

export default Input;
